import { SIGNUP_SUCCESS } from 'actiontypes/registration';
import * as UserActionTypes from 'actiontypes/user';

import facebookLoginFailure from './facebookLoginFailure';
import signupSuccess from './signupSuccess';


/**
 * Initial state
 * @type {Object}
 */
const initialState = {
  loggedIn: false,
  isFetching: false,
  loginError: false,
  user: {},
  privilegeLevel: null,
};


/**
 * User Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const User = (state = initialState, action) => {
  const { payload = {} } = action;

  switch (action.type) {
    case UserActionTypes.LOGIN_REQUESTED:
      return {
        ...state,
        isFetching: true,
        loggedIn: false,
        loginError: false,
      };

    case UserActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        loggedIn: false,
        loginError: true,
      };

    case UserActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        hasCharacter: payload.hasCharacter,
        loggedIn: payload.loggedIn,
        user: payload.user,
        snippets: payload.snippets,
        privilegeLevel: payload.privilegeLevel,
      };

    case SIGNUP_SUCCESS:
      if (payload.isSuccess) {
        return signupSuccess(state, payload);
      }
      return state;

    case UserActionTypes.LOGOUT_REQUESTED:
    case UserActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        loggedIn: action.loggedIn,
      };

    case UserActionTypes.TWITTER_LOGIN_SUCCESS:
    case UserActionTypes.FACEBOOK_LOGIN_SUCCESS:
      return {
        ...state,
        hasCharacter: payload.hasCharacter,
        isFetching: false,
        loggedIn: payload.loggedIn,
        user: payload.user,
      };

    case UserActionTypes.FACEBOOK_LOGIN_FAILURE:
      return facebookLoginFailure(state, payload);

    case UserActionTypes.GOOGLE_LOGIN_FAILURE:
      return {
        ...state,
        loginError: true, // TODO: is this right? Does something depend on this?
        loggedIn: false,
        isFetching: false,
      };

    case UserActionTypes.TWITTER_LOGIN_FAILURE:
    case UserActionTypes.FACEBOOK_LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        loggedIn: false,
        loginError: true,
      };

    case UserActionTypes.GOOGLE_LOGIN_REQUESTED:
      return {
        ...state,
        isFetching: true,
        loggedIn: false,
        loginError: false,
      };

    case UserActionTypes.GOOGLE_LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        loggedIn: false,
        loginError: true,
      };

    case UserActionTypes.GOOGLE_LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        loggedIn: true,
        hasCharacter: payload.hasCharacter,
        user: payload.user,
      };

    case UserActionTypes.ALLOW_LOGIN_FROM_APP_SUCCESS:
      return {
        ...state,
        loggedIn: action.loggedIn,
      };
    default:
      return state;
  }
};

export default User;
